// extracted by mini-css-extract-plugin
module.exports = {"selectedSitesTable":"NewGroupModal_selectedSitesTable__108hW"};